import { takeLatest } from 'redux-saga/effects'
import * as types from '../redux/types'
import { submitContactUsSaga } from './Sagas'

export const contactUsSagas = [takeLatest(types.SUBMIT_CONTACT_MESSAGE, submitContactUsSaga)]
